import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { StockAvailablityValueResponse, useDashboardPieType } from "../../types";

export const useStockAvailablityValue = ({ date, location_id }: useDashboardPieType) => {
  const api = useApi();
  const [data, setData] = useState<StockAvailablityValueResponse[]>([]);

  const params: Record<string, string | number> = {
    year_month: date,
    ...(location_id && { location_id }),
  };

  const fetchData = () => {
    api.get("/dasboard_inventory/stock_availability_value", { params })
    .then((res: SuccessFetch<{ payload: StockAvailablityValueResponse[] }>) => {
      const payload = res.data.payload;
      setData(payload);
    })
    .catch(() => setData([]));
  };

  useEffect(() => {
    fetchData();
    return () => setData([]);

    // eslint-disable-next-line
  }, [date, location_id]);

    return { fetchData, data };
}
